import {connect} from '@gisatcz/ptr-state';
import Presentation from './presentation';
import Select from '../../../../state/Select';
import Action from '../../../../state/Action';

const componentId = 'BenchmarkSidePanel';

const mapStateToProps = state => {
	return {
		open: Select.components.get(state, componentId, 'open'),
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setOpen: open => dispatch(Action.components.set(componentId, 'open', open)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Presentation);
